<template>
  <p class="clearfix mb-0" :style="(isMobile()) ? 'text-align: center;' : '' ">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      COPYRIGHT  © 2022
      <b-link
        class="ml-25"
        href="http://www.flexocraft.com/"
        target="_blank"
      >Flexocraft</b-link>
      <span class="d-none d-sm-inline-block">, All Rights Reserved</span>
    </span>

    
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
  methods: {
    isMobile() {
       if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
         return true
       } else {
         return false
       }
     },
  }
}
</script>
